import { GlobalState } from '../index';

export const selectBanners = (state: GlobalState) => state.advertising.banners;
export const selectLoadingBanners = (state: GlobalState) => state.advertising.loading;
export const selectAdTags = (state: GlobalState) => state.advertising.adProducts;
